import { Table } from "antd";
import { getGiftCardRequestHistory } from "../../../api/trade";
import { useQuery } from "react-query";
import { giftCardRequestHistoryColumn } from "../../customers/column";
import { useEffect, useState } from "react";
import GiftCardRequestDetail from "./GiftCardRequestDetail";
import DeclineGiftCardTrade from "./DeclineGiftCardTrade";

const GiftCardRequestHistory = () => {
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [recordId, setRecordId] = useState('');
  const [singleData, setSingleData] = useState({});

    const [permissions, setPermissions] = useState(null);
    
      useEffect(() => {
        const ls = localStorage.getItem("permissions");
        try {
          const parsedLs = JSON.parse(ls);
          setPermissions(parsedLs);
        } catch (error) {}
      }, []);
    
      const getModulePermission = (module, section) => {
        const pers = permissions?.find(
          (per) =>
            String(per?.module?.toLowerCase()) === String(module.toLowerCase()),
        )?.permissions;
        return pers ? pers[section] : false;
      };

  const { data, isLoading } = useQuery(["gift-card-history"], () =>
    getGiftCardRequestHistory()
  );

  const handleRowClick = (record) => {
    setSingleData(record || {});
    setOpen(true);
  };

  return (
    <div>
      <GiftCardRequestDetail
        open={open}
        setOpen={setOpen}
        record={singleData}
        openModal={openModal} 
        setOpenModal={setOpenModal}
        setRecordId={setRecordId}
      />
      <Table
        loading={isLoading}
        dataSource={data?.requests || []}
        columns={giftCardRequestHistoryColumn}
        rowClassName="cursor-pointer hover:bg-gray-50"
        onRow={(record) => {
          return {
            onClick: () => getModulePermission("trade", "canTreat") ? handleRowClick(record) : undefined,
          };
        }}
      />
      {openModal && <DeclineGiftCardTrade id={recordId} open={openModal} setOpen={setOpenModal} />}
    </div>
  );
};

export default GiftCardRequestHistory;
